import { Divider, Typography } from 'antd';
import { Datagrid } from 'components';
import saveAs from 'file-saver';
import { useTranslation } from 'react-i18next';
import { ToolTest } from 'app/types/tool';

const ToolTestInfo = ({ test }: { test: ToolTest }) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    if (!test.ReportUrl) return;
    const fileName = test.ReportFileName ? test.ReportFileName.replaceAll('"', '') : 'report';
    saveAs(test.ReportUrl, fileName);
  };

  const tags = [
    { key: 'IsSuccessful', value: true, color: 'success', message: t('entities.tooltest.result.success') },
    { key: 'IsSuccessful', value: false, color: 'error', message: t('entities.tooltest.result.failure') },
  ];

  return (
    <>
      <Datagrid
        data={test}
        keys={[ 'ExecutedAt', 'ValidTo', 'IsSuccessful', 'ExecutorName', 'CompanyName', 'ReportUrl' ]}
        tags={tags}
        translationsNamespace={'entities.tooltest'}
        dateOnlyKeys={[ 'ExecutedAt', 'ValidTo' ]}
        links={[ {
          key: 'ReportUrl',
          message: t('common.downloadreport'),
          onClick: handleDownload
        }
        ]}/>
      {test.Comment ? <Divider orientation='left'>{t('entities.tooltest.comment')}</Divider> : null}
      {test.Comment && <Typography.Paragraph>{test.Comment}</Typography.Paragraph>}
    </>
  );
};

export default ToolTestInfo;